import type { CSSProperties, ReactNode } from 'react';
import { Card } from 'react-bootstrap';

export type BaseCardProps = {
  title?: ReactNode;
  header?: ReactNode;
  headerClassName?: string;
  imageSrc?: string;
  imageVariant?: 'top' | 'bottom' | 'left' | 'right' | string;
  className?: string;
  bodyClassName?: string;
  bodyStyle?: CSSProperties;
  children?: ReactNode;
} & {};

const BaseCard = ({
  title,
  header,
  headerClassName = '',
  imageSrc,
  imageVariant = 'top',
  className = '',
  bodyClassName = '',
  bodyStyle = {},
  children = null,
}: BaseCardProps): JSX.Element => {
  return (
    <Card className={className}>
      {imageSrc && <Card.Img variant={imageVariant} src={imageSrc} />}
      {header && <Card.Header className={headerClassName}>{header}</Card.Header>}
      <Card.Body className={bodyClassName} style={bodyStyle}>
        {title && <Card.Title>{title}</Card.Title>}
        {children}
      </Card.Body>
    </Card>
  );
};

export default BaseCard;
